<script setup lang="ts">
import {computed, watchEffect} from "vue";
import {useApiService} from "@/api/api.service.ts";
import type {IStoreDefault, IStoreDistanceDefault} from "@/api/aj-trends.model.ts";
import {IOpeningHours} from "@/api/opening-hours.model.ts";
import {catchRateLimitExceeded} from "@/service/rateLimitHandler.ts";
import OpeningHours from "@/components/OpeningHours.vue";
import StoreMap from "@/components/StoreMap.vue";

const props = defineProps<{
  dataStore: string,
  dataNearby: string,
}>()

const store = computed(() => {
  return JSON.parse(props.dataStore) as IStoreDefault;
})
const nearby = computed(() => {
  const allNearby = JSON.parse(props.dataNearby) as ReadonlyArray<IStoreDistanceDefault>;
  // Only include nearby stores with an image
  return allNearby.filter(i => Boolean(i.destinationStore.image))
})

const api = useApiService()

watchEffect(() => {
  api.fetchStoreData(store.value.id)
      .catch(catchRateLimitExceeded)
})

const openingHours = computed<null | IOpeningHours>(() => {
  const hoursJson = store.value.hours
  return hoursJson ? IOpeningHours.parseOpeningHoursFromArray(JSON.parse(hoursJson)) : null;
})
</script>

<template>
  <div class="row align-self-center mx-auto">
    <div class="col-lg-7 g-mb-15 g-mt-0--md g-mt-50">
      <div class="col-lg-12">
        <StoreMap :store="store" :nearby="nearby"/>
      </div>
    </div>
    <div class="col-lg-5 g-mb-15">
      <OpeningHours v-if="openingHours" :store="store" :opening-hours="openingHours"/>
    </div>
  </div>
</template>
